import React, { Component } from 'react';
import { connect } from 'react-redux';
// utils
import { Translations } from '../../../../utils/';
// constant
import { FORM_REFS } from '../../../../constants';
// restClient
import { aemHostClient, eapiClient } from '../../../../restClient';
// children
import Dynamicform from '../../../common/Dynamicform/dynamicForm';
//style
import './styles.css';

class CreateNewEchannelAddress extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    let apiURL = "/aemData/formData/json_create-address";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("create-", "edit-");
    }
    aemHostClient(apiURL)
      .then(({ data }) => {
        document.title = `${data.title} - ${'HSBC GLCM'}`;
        this.setState({ formJson: data });
      });
  }

  getFormData = (formData) => {
    this.setState({ formData });
  }

  onFormSubmit = (event, apiURL) => {
    var requestData = {
      ...this.state.formData,
      caseId: this.props.caseId
    };
    requestData.entityId = this.props.entityId;
    if (this.props.mode === 'edit') {
      apiURL = apiURL + "/" + this.state.formData.id;
    }

    var METHOD = this.props.mode === 'edit' ? 'PUT' : 'POST';
    eapiClient(apiURL, {
      method: METHOD,
      data: JSON.stringify(requestData)
    })
      .then(({ data }) => {
        var key = window.sessionStorage.getItem("getCurrentDropDown");
        window.sessionStorage.setItem('key' + key, data.responseData.id);
        this.props.history.goBack();
      });
  }

  onFormCancel = () => {
    this.props.history.goBack();
  }

  renderFormGroups() {
    let formData;
    if (this.props.currentAddress !== undefined) {
      formData = { ...this.props.currentAddress };
    } else {
      formData = {};
    }
    const properties = {
      addressId: this.props.match.params.addressId,
      addressType: this.props.match.params.addressType,
      formData,
      editType: 'create-new-echannel-address',
      pathname: this.props.history.location.pathname
    };
    if (this.state.formJson !== undefined && this.state.formJson.par.aemform_ !== undefined) {
      return (
        <Dynamicform mode={this.props.mode}
          properties={properties}
          url={FORM_REFS[this.state.formJson.par.aemform_.formRef]}
          getFormData={this.getFormData}
          history={this.props.history}
          match={this.props.match}
          onFormSubmit={this.onFormSubmit}
          onFormCancel={this.onFormCancel}
          lang={this.props.lang.currentLang.lang}
          translatedData={this.props.lang.translatedData}
          flag={this.props.lang.currentLangFlag.flag}
        />
      );
    }
  }

  render() {
    const pageTitle = this.state.formJson ? this.state.formJson.par.page_title_mainTitle : '';
    return (
      <div className="form-container">
        <div className="form-title">
          <h2 className="form-heading">
            {Translations(pageTitle.pageHeading, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </h2>
          <p className="form-required-desc">
            {Translations(pageTitle.descriptionText, this.props.lang.currentLang.lang, this.props.lang.translatedData)}
          </p>
        </div>
        {this.renderFormGroups()}
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  let currentAddress = undefined;
  if (props.match.params) {
    var { addressId } = props.match.params;
    if (addressId && state.addresses.length > 0) {
      state.addresses.forEach(address => {
        if (address.id === addressId) {
          currentAddress = address;
        }
      });
    }
  }
  return {
    currentAddress,
    mode: currentAddress !== undefined ? 'edit' : '',
    entityId: state.cases[state.currentProductEchannel.data.caseId].entityId,
    caseId: state.cases[state.currentProductEchannel.data.caseId].caseId,
    lang: state.lang
  };
}

export default connect(mapStateToProps)(CreateNewEchannelAddress);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductEchannel/CreateNewEchannelAddress.js